import {
  Select as MuiSelect,
  type SelectChangeEvent as MuiSelectChangeEvent,
  type SelectProps as MuiSelectProps
} from '@mui/material';

export type SelectProps<T = unknown> = MuiSelectProps<T>;

export type SelectChangeEvent<T = string> = MuiSelectChangeEvent<T>;

export const Select = <T = unknown,>(props: Readonly<SelectProps<T>>) => (
  <MuiSelect<T> {...props} />
);
